export * from './svgIcon.component';
